var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStampRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797777"
    },
    d: "M56,16c0-1.299-0.619-2.454-1.579-3.184c-0.549-0.418-0.549-1.213,0-1.631 C55.381,10.454,56,9.299,56,8c0-1.954-1.401-3.581-3.254-3.931c-0.417-0.079-0.736-0.398-0.815-0.815C51.581,1.401,49.954,0,48,0 c-1.299,0-2.454,0.619-3.184,1.579c-0.418,0.549-1.213,0.549-1.631,0C42.454,0.619,41.299,0,40,0s-2.454,0.619-3.184,1.579 c-0.418,0.549-1.213,0.549-1.631,0C34.454,0.619,33.299,0,32,0c-1.299,0-2.454,0.619-3.184,1.579c-0.418,0.549-1.213,0.549-1.631,0 C26.454,0.619,25.299,0,24,0s-2.454,0.619-3.184,1.579c-0.418,0.549-1.213,0.549-1.631,0C18.454,0.619,17.299,0,16,0 s-2.454,0.619-3.184,1.579c-0.418,0.549-1.213,0.549-1.631,0C10.454,0.619,9.299,0,8,0C6.046,0,4.419,1.401,4.069,3.254 C3.991,3.672,3.672,3.991,3.254,4.069C1.401,4.419,0,6.046,0,8c0,1.299,0.619,2.454,1.579,3.184c0.549,0.418,0.549,1.213,0,1.631 C0.619,13.546,0,14.701,0,16c0,1.299,0.619,2.454,1.579,3.184c0.549,0.418,0.549,1.213,0,1.631C0.619,21.546,0,22.701,0,24 c0,1.299,0.619,2.454,1.579,3.184c0.549,0.418,0.549,1.213,0,1.631C0.619,29.546,0,30.701,0,32c0,1.299,0.619,2.454,1.579,3.184 c0.549,0.418,0.549,1.213,0,1.631C0.619,37.546,0,38.701,0,40c0,1.299,0.619,2.454,1.579,3.184c0.549,0.418,0.549,1.213,0,1.631 C0.619,45.546,0,46.701,0,48c0,1.954,1.402,3.581,3.254,3.931c0.417,0.079,0.736,0.398,0.815,0.815C4.419,54.598,6.046,56,8,56 c1.299,0,2.454-0.619,3.184-1.579c0.418-0.549,1.213-0.549,1.631,0C13.546,55.381,14.701,56,16,56s2.454-0.619,3.184-1.579 c0.418-0.549,1.213-0.549,1.631,0C21.546,55.381,22.701,56,24,56s2.454-0.619,3.184-1.579c0.418-0.549,1.213-0.549,1.631,0 C29.546,55.381,30.701,56,32,56s2.454-0.619,3.184-1.579c0.418-0.549,1.213-0.549,1.631,0C37.546,55.381,38.701,56,40,56 s2.454-0.619,3.184-1.579c0.418-0.549,1.213-0.549,1.631,0C45.546,55.381,46.701,56,48,56c1.954,0,3.581-1.402,3.931-3.254 c0.079-0.417,0.398-0.736,0.815-0.815C54.598,51.581,56,49.954,56,48c0-1.299-0.619-2.454-1.579-3.184 c-0.549-0.418-0.549-1.213,0-1.631C55.381,42.454,56,41.299,56,40c0-1.299-0.619-2.454-1.579-3.184 c-0.549-0.418-0.549-1.213,0-1.631C55.381,34.454,56,33.299,56,32c0-1.299-0.619-2.454-1.579-3.184 c-0.549-0.418-0.549-1.213,0-1.631C55.381,26.454,56,25.299,56,24c0-1.299-0.619-2.454-1.579-3.184 c-0.549-0.418-0.549-1.213,0-1.631C55.381,18.454,56,17.299,56,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c93b42"
    },
    d: "M47.282,49H8.718C7.769,49,7,48.231,7,47.282V8.718C7,7.769,7.769,7,8.718,7h38.565 C48.231,7,49,7.769,49,8.718v38.565C49,48.231,48.231,49,47.282,49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M24,45c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S27.309,45,24,45z M24,35c-2.206,0-4,1.794-4,4 s1.794,4,4,4s4-1.794,4-4S26.206,35,24,35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M36.001,37c-0.288,0-0.573-0.123-0.771-0.361c-0.684-0.824-1.777-0.824-2.461,0 c-0.351,0.424-0.981,0.485-1.408,0.131c-0.425-0.353-0.483-0.982-0.131-1.408C31.958,34.483,32.942,34,34,34 s2.042,0.483,2.77,1.361c0.353,0.426,0.294,1.056-0.131,1.408C36.452,36.925,36.226,37,36.001,37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M38,38c-1.058,0-2.042-0.483-2.77-1.361c-0.353-0.426-0.294-1.056,0.131-1.408 c0.426-0.354,1.058-0.294,1.408,0.131c0.684,0.824,1.777,0.824,2.461,0c0.352-0.424,0.983-0.484,1.408-0.131 c0.425,0.353,0.483,0.982,0.131,1.408C40.042,37.517,39.058,38,38,38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M44.001,37c-0.288,0-0.573-0.123-0.771-0.361c-0.684-0.824-1.777-0.824-2.461,0 c-0.352,0.424-0.982,0.485-1.408,0.131c-0.425-0.353-0.483-0.982-0.131-1.408C39.958,34.483,40.942,34,42,34 s2.042,0.483,2.77,1.361c0.353,0.426,0.294,1.056-0.131,1.408C44.452,36.925,44.226,37,44.001,37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M36.001,43c-0.288,0-0.573-0.123-0.771-0.361c-0.684-0.824-1.777-0.824-2.461,0 c-0.351,0.425-0.981,0.486-1.408,0.131c-0.425-0.353-0.483-0.982-0.131-1.408C31.958,40.483,32.942,40,34,40 s2.042,0.483,2.77,1.361c0.353,0.426,0.294,1.056-0.131,1.408C36.452,42.925,36.226,43,36.001,43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M38,44c-1.058,0-2.042-0.483-2.77-1.361c-0.353-0.426-0.294-1.056,0.131-1.408 c0.426-0.354,1.058-0.294,1.408,0.131c0.684,0.824,1.777,0.824,2.461,0c0.352-0.424,0.983-0.484,1.408-0.131 c0.425,0.353,0.483,0.982,0.131,1.408C40.042,43.517,39.058,44,38,44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#570881"
    },
    d: "M44.001,43c-0.288,0-0.573-0.123-0.771-0.361c-0.684-0.824-1.777-0.824-2.461,0 c-0.352,0.425-0.982,0.486-1.408,0.131c-0.425-0.353-0.483-0.982-0.131-1.408C39.958,40.483,40.942,40,42,40 s2.042,0.483,2.77,1.361c0.353,0.426,0.294,1.056-0.131,1.408C44.452,42.925,44.226,43,44.001,43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 42,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 21,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 27,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 33,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 39,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 45,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 18,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 24,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 30,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 36,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 42,
    cy: 30,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 21,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 27,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 33,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 39,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 45,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 18,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 24,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 30,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 36,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 42,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 15,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 21,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 27,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 33,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 39,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 45,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 18,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 24,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 30,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 36,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 42,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 18,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 24,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 30,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 36,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#570881"
    },
    cx: 42,
    cy: 12,
    r: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampRed);
export default __webpack_public_path__ + "static/media/stamp-red.89e5a3ef18bd144b42df3bc871674f5b.svg";
export { ForwardRef as ReactComponent };